import { useNavigate, useBlocker } from "react-router-dom";
import { useConfirmation } from "./ConfirmationDialogContext";

/**
 * A wrapper around navigate() that supports optional confirmation dialog.
 *
 * TODO This works OK for now, but there's actually a better way.
 * This way leaves gaps: it requires <A> tags and similar to all be modified to use this hook.
 * Which is likely to get forgotten, plus hard to do for components that aren't directly connected to the page that wants to use this 
 * (and we have several things that do miss the current check -- e.g. navbar clicks).
 
* The better way is to intercept navigation events.

 * Which can be done with the useBlocker() react-router hook.
 * Note: It can also be done lower-level with window.addEventListener()
 * Then the page that wants to control navigation manages the blocker -- which will kick in for any navigation trigger.
 * 
 * @returns {(to: string | object, confirmConfig: object, navigateOptions: object) => void}
 */
export const useConfirmedNavigate = () => {
  const navigate = useNavigate();
  const { confirm } = useConfirmation();

  /**
   * @param {string|object} to - Route path or object (same as react-router)
   * @param {object} confirmConfig - { confirm, title, message, confirmText, cancelText }
   * @param {object} navigateOptions - { replace, state }
   */
  const confirmedNavigate = async (
    to,
    { confirm: shouldConfirm = false, title, message, confirmText, cancelText } = {},
    navigateOptions = {}
  ) => {
    if (shouldConfirm) {
      const confirmed = await confirm({ title, message, confirmText, cancelText });
      if (!confirmed) return;
    }

    navigate(to, navigateOptions);
  };

  return confirmedNavigate;
};
